<template>
  <div class="approval-needed-users">
    <div class="col-md-12">
      <h2 class="table-title">Assigned Approvers</h2>
      <table class="custom-table">
        <thead>
          <tr>
            <th>Name:</th>
            <th>Email:</th>
            <th>Phone:</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in approvalUsersData" :key="user.id" v-if="user.IsCurrentAction">
            <td>{{ user.FirstName }} {{ user.LastName }}</td>
            <td>{{ user.Email }}</td>
            <td>{{ user.Phone }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-12" v-if="hasNextAssignedApprovers">
      <h2 class="table-title">Next Assigned Approvers</h2>
      <table class="custom-table">
        <thead>
          <tr>
            <th>Name:</th>
            <th>Email:</th>
            <th>Phone:</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in approvalUsersData" :key="user.id" v-if="!user.IsCurrentAction">
            <td>{{ user.FirstName }} {{ user.LastName }}</td>
            <td>{{ user.Email }}</td>
            <td>{{ user.Phone }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        card: []
      }
    },
    props: {
      approvalUsersData: Object
    },
    computed: {
      hasNextAssignedApprovers() {
        return this.approvalUsersData.some(user => !user.IsCurrentAction)
      }
    },
    methods: {
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>
  .approval-needed-users {
    background-color: white;
    padding: 10px;
  }

  .custom-table {
    width: 100%;
  }

  .custom-table th,
  .custom-table td {
    padding: 10px;
    border-bottom: 1px solid #ddd;
  }

  .table-title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/ApprovalNeededUsers.vue